import { ContactRole } from '../generated/graphql';
import { ContactRoleTypesLabelArray } from '../types';

const translateRole = (role: ContactRole) => {
  const found = ContactRoleTypesLabelArray.find((r) => r.value === role);
  return found ? found.label : role;
};

export const formatContactRole = (role: ContactRole) => {
  return translateRole(role);
};
